export default __webpack_public_path__ + "static/media/staff.4ede8286.jpg";